import { render } from "./BlockTitle.vue?vue&type=template&id=17b9e731"
const script = {}

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__